export const isQA = (domain: string): boolean => {
    return domain.includes('evbqa');
};

export const isProd = (domain: string): boolean => {
    return domain.includes('eventbrite');
};
